import { colors } from '~/styles/colors';

type XIconProps = {
  color?: string;
  height?: string;
  width?: string;
}

export const XIcon = ({
  color = colors.icon['soft-400'],
  width = '14',
  height = '14',
}: Readonly<XIconProps>): JSX.Element => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 14 14"
  >
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M13 1 1 13M1 1l12 12"
    />
  </svg>
);
